/* Tiny fetch wrapper for the viewer API. Token is in localStorage. */
const API = process.env.REACT_APP_BACKEND_URL + "/api/viewer";
const TOKEN_KEY = "tbg_viewer_token";
const TOKEN_EXP_KEY = "tbg_viewer_token_exp";

export const getToken = () => {
  const exp = localStorage.getItem(TOKEN_EXP_KEY);
  if (exp && new Date(exp) < new Date()) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_EXP_KEY);
    return null;
  }
  return localStorage.getItem(TOKEN_KEY);
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXP_KEY);
};

const headers = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const login = async (password) => {
  const res = await fetch(`${API}/auth`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.detail || `HTTP ${res.status}`);
  }
  const data = await res.json();
  localStorage.setItem(TOKEN_KEY, data.token);
  localStorage.setItem(TOKEN_EXP_KEY, data.expires_at);
  return data;
};

export const listDatasets = async () => {
  const res = await fetch(`${API}/datasets`, { headers: headers() });
  if (res.status === 401) throw new Error("UNAUTHORIZED");
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const uploadDataset = async (file, onProgress) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const t = getToken();
    xhr.open("POST", `${API}/upload`);
    if (t) xhr.setRequestHeader("Authorization", `Bearer ${t}`);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total);
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try { resolve(JSON.parse(xhr.responseText)); }
        catch (e) { reject(e); }
      } else {
        let msg = `HTTP ${xhr.status}`;
        try { msg = JSON.parse(xhr.responseText).detail || msg; } catch (e) { /* noop */ }
        reject(new Error(msg));
      }
    };
    xhr.onerror = () => reject(new Error("Network error"));
    const fd = new FormData();
    fd.append("file", file);
    xhr.send(fd);
  });
};

export const deleteDataset = async (id) => {
  const res = await fetch(`${API}/datasets/${id}`, {
    method: "DELETE",
    headers: headers(),
  });
  if (!res.ok && res.status !== 204) throw new Error(`HTTP ${res.status}`);
};

export const previewUrlFor = (id) => `${API}/datasets/${id}/preview.png`;
export const heightmapUrlFor = (id) => `${API}/datasets/${id}/heightmap.png`;
export const fileUrlFor = (id) => `${API}/datasets/${id}/file`;

/* Fetch an image as blob URL with auth headers. Returns object URL. */
export const fetchAuthedBlob = async (url) => {
  const res = await fetch(url, { headers: headers() });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const blob = await res.blob();
  return URL.createObjectURL(blob);
};

/* Same but returns the raw ArrayBuffer (for Three.js loaders that want it). */
export const fetchAuthedBuffer = async (url) => {
  const res = await fetch(url, { headers: headers() });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.arrayBuffer();
};
